import { LegalPage, Clause, LegalFooterNote } from "../components/LegalPage";

export default function Privacy() {
  return (
    <LegalPage overline="The small print" title="Privacy Policy" updated="June 2026" testId="privacy-page">
      <Clause heading="What this site is">
        <p>
          This is a personal library — a catalogue of books, essays and reading curriculums kept by Tirthak Saha.
          You can read everything here without an account. Signing in is optional, and only exists so the site can
          remember your reading list, your notes and how far you have progressed through a curriculum.
        </p>
      </Clause>

      <Clause heading="What is collected">
        <p>If you sign in with Google, this site receives and stores only:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>your name, email address and profile picture URL, as provided by Google;</li>
          <li>the entries you add to your TBR list;</li>
          <li>notes you write against an entry;</li>
          <li>which curriculum steps you have marked complete.</li>
        </ul>
        <p>
          If you never sign in, nothing about you is stored. Passwords are never collected — authentication is
          handled entirely by Google, and this site never sees your Google password.
        </p>
      </Clause>

      <Clause heading="How it is used">
        <p>
          Your data is used for exactly one purpose: showing you your own reading list, notes and progress when you
          return. It is never sold, rented, shared with advertisers, or used to build a profile of you. There is no
          advertising on this site and no marketing email is ever sent.
        </p>
      </Clause>

      <Clause heading="Who can see it">
        <p>
          Your reading list, notes and progress are yours. They are never published, shared with third parties, sold,
          or used for anything other than showing them back to you.
        </p>
        <p>
          The site is run by one person, and that person can look up an account in an administrative view when there
          is a reason to — answering a question you have emailed about, fixing something that has gone wrong with your
          list or your progress, or removing your account when you ask. That view reads directly from this site's own
          database; nothing about you is copied out of it, kept in a separate file, or held anywhere else. No one else
          has access to it.
        </p>
        <p>
          If you would rather leave nothing behind at all, you can delete your account and everything attached to it
          from your account page at any time.
        </p>
      </Clause>

      <Clause heading="Where it lives">
        <p>
          Data is stored in a private database used only by this site. Sessions are kept in a secure, http-only
          cookie so your browser can stay signed in; that cookie contains a random session token and nothing else.
          Book cover images and artwork are cached on the server to keep pages fast.
        </p>
      </Clause>

      <Clause heading="How long it is kept">
        <p>
          Your reading list, notes and progress are kept until you delete them or ask for your account to be removed.
          Sign-in sessions expire after seven days of inactivity.
        </p>
      </Clause>

      <Clause heading="Your choices">
        <p>
          You can remove any entry from your TBR list or delete any note at any time from your account page. You can
          sign out to end a session. To have your account and everything attached to it deleted, email the address
          below and it will be removed.
        </p>
      </Clause>

      <Clause heading="Google user data">
        <p>
          This site's use of information received from Google APIs adheres to the Google API Services User Data
          Policy, including the Limited Use requirements. The only scopes requested are your basic profile, your email
          address and OpenID — enough to know who you are when you come back. No Gmail, Drive, Calendar or contact
          data is ever requested or accessed.
        </p>
      </Clause>

      <Clause heading="Contact">
        <p>
          Questions, or a request to delete your data: <a href="mailto:hello@tirthaksaha.com" className="text-brass link-underline">hello@tirthaksaha.com</a>.
        </p>
      </Clause>

      <LegalFooterNote>If this policy changes, the date at the top changes with it.</LegalFooterNote>
    </LegalPage>
  );
}
